import { createFileRoute } from '@tanstack/react-router'
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_auth/checkout-cancel')({
  component: CheckoutCancelComponent,
})

function CheckoutCancelComponent() {
  const navigate = useNavigate();
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const returnToParam = searchParams?.get('returnTo') || undefined;

  useEffect(() => {
    // 1) If API provided a returnTo param, prefer it (safely handle only same-origin paths)
    if (returnToParam && returnToParam.startsWith('/')) {
      navigate({ to: returnToParam as any });
      return;
    }
    // 2) Try to jump back two steps: [config page] -> [stripe] -> [this page]
    if (typeof window !== 'undefined' && window.history.length > 2) {
      // Fallback in case history navigation is blocked or fails
      const fallback = setTimeout(() => {
        navigate({ to: '/subscribe', search: { plan: undefined, billing: undefined, discount: undefined } });
      }, 100);
      try {
        window.history.go(-2);
      } catch {
        navigate({ to: '/subscribe', search: { plan: undefined, billing: undefined, discount: undefined } });
      }
      return () => clearTimeout(fallback);
    }
    // 3) Final fallback
    navigate({ to: '/subscribe', search: { plan: undefined, billing: undefined, discount: undefined } });
  }, [navigate, returnToParam]);

  const handleGoBackToCheckout = () => {
    navigate({ to: '/subscribe', search: { plan: undefined, billing: undefined, discount: undefined } });
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center max-w-md mx-auto p-8 border border-gray-200 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold mb-4 text-red-600">Payment Cancelled</h1>
        <p className="text-lg text-gray-700 mb-4">
          Your payment was not completed and you have not been charged. Returning you to your checkout configuration.
        </p>
        <button
          className="mt-4 px-6 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 transition-colors font-semibold"
          onClick={handleGoBackToCheckout}
        >
          Return to Checkout
        </button>
      </div>
    </div>
  )
} 